var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddDatascience({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1377 9.85406C2.1377 9.46894 2.4499 9.15674 2.83502 9.15674H7.71629C8.10141 9.15674 8.41362 9.46894 8.41362 9.85406C8.41362 10.2392 8.10141 10.5514 7.71629 10.5514H3.53234V16.13C3.53234 16.5151 3.22014 16.8273 2.83502 16.8273C2.4499 16.8273 2.1377 16.5151 2.1377 16.13V9.85406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.743164 16.1304C0.743164 15.7453 1.05537 15.4331 1.44049 15.4331H18.8736C19.2587 15.4331 19.5709 15.7453 19.5709 16.1304C19.5709 16.5156 19.2587 16.8278 18.8736 16.8278H1.44049C1.05537 16.8278 0.743164 16.5156 0.743164 16.1304Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01953 5.67047C7.01953 5.28535 7.33173 4.97314 7.71686 4.97314H12.5981C12.9832 4.97314 13.2955 5.28535 13.2955 5.67047C13.2955 6.05559 12.9832 6.36779 12.5981 6.36779H8.41418V16.1303C8.41418 16.5155 8.10198 16.8277 7.71686 16.8277C7.33173 16.8277 7.01953 16.5155 7.01953 16.1303V5.67047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9004 1.48639C11.9004 1.10127 12.2126 0.789062 12.5977 0.789062H17.479C17.8641 0.789062 18.1763 1.10127 18.1763 1.48639V16.1302C18.1763 16.5153 17.8641 16.8275 17.479 16.8275H12.5977C12.2126 16.8275 11.9004 16.5153 11.9004 16.1302V1.48639ZM13.295 2.18371V15.4329H16.7817V2.18371H13.295Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDatascience);
export default __webpack_public_path__ + "static/media/add_datascience.7145d70b.svg";
export { ForwardRef as ReactComponent };